/**
 * QualitySewing.com - Vacuum Compare Tray
 * Lightweight overlay: "Add to Compare" button on vacuum
 * product pages + persistent floating comparison tray across all pages.
 *
 * Uses separate localStorage key + events from the sewing machine
 * compare tray so both can run on the same site without conflict.
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'qsv-compare-vacuums';
  var MAX_COMPARE = 3;
  var container = document.getElementById('qsv-vacuum-compare-tray');
  if (!container) return;

  var COMPARE_PAGE = container.getAttribute('data-compare-page') || '/pages/vacuum-comparison';
  var isVacuum = container.getAttribute('data-is-vacuum') === 'true';

  // Detect if we're on the vacuum comparison page
  var isOnComparePage = !!document.getElementById('vacuum-compare-app');

  // Current product data (only populated on vacuum product pages)
  var currentProduct = null;
  if (isVacuum) {
    currentProduct = {
      handle: container.getAttribute('data-product-handle'),
      title: container.getAttribute('data-product-title'),
      image: container.getAttribute('data-product-image'),
      url: container.getAttribute('data-product-url'),
      price: container.getAttribute('data-product-price')
    };
  }

  // ---- State ----

  var vacuums = loadState();
  var _broadcasting = false;

  function loadState() {
    try {
      var data = localStorage.getItem(STORAGE_KEY);
      if (data) {
        var parsed = JSON.parse(data);
        if (Array.isArray(parsed)) {
          return parsed.filter(function(v) { return v && v.handle; }).slice(0, MAX_COMPARE);
        }
      }
    } catch (e) {}
    return [];
  }

  function saveState() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(vacuums));
    } catch (e) {}
  }

  function isSelected(handle) {
    return vacuums.some(function(v) { return v.handle === handle; });
  }

  function broadcastUpdate() {
    _broadcasting = true;
    window.dispatchEvent(new CustomEvent('qsv-vacuum-compare-updated', {
      detail: { handles: vacuums.map(function(v) { return v.handle; }) }
    }));
    _broadcasting = false;
  }

  // ---- Tray Rendering ----

  var trayEl = null;
  var maxMsgTimeout = null;

  function buildTrayHtml() {
    var itemsHtml = vacuums.map(function(v) {
      return '<div class="qsv-vct-item" data-handle="' + v.handle + '">' +
        '<img class="qsv-vct-item-img" src="' + (v.image || '') + '" alt="" loading="lazy">' +
        '<span class="qsv-vct-item-name">' + escapeHtml(v.title) + '</span>' +
        '<button class="qsv-vct-item-remove" data-handle="' + v.handle + '" aria-label="Remove">&times;</button>' +
      '</div>';
    }).join('');

    // On the comparison page, Compare Now triggers the view directly via event
    var compareAction = isOnComparePage
      ? '<button class="qsv-vct-compare-btn" type="button">Compare Now</button>'
      : '<a class="qsv-vct-compare-btn" href="' + buildCompareUrl() + '">Compare Now</a>';

    return '<div class="qsv-vct-tray">' +
      '<div class="qsv-vct-header">' +
        '<span class="qsv-vct-title">Compare Vacuums</span>' +
        '<span class="qsv-vct-count">' + vacuums.length + ' of ' + MAX_COMPARE + '</span>' +
        '<button class="qsv-vct-collapse" aria-label="Toggle tray">&#x25BC;</button>' +
      '</div>' +
      '<div class="qsv-vct-items">' + itemsHtml + '</div>' +
      '<div class="qsv-vct-max-msg">Remove a vacuum to add another.</div>' +
      '<div class="qsv-vct-actions">' +
        '<button class="qsv-vct-clear">Clear All</button>' +
        compareAction +
      '</div>' +
    '</div>';
  }

  function renderTray() {
    if (trayEl) {
      trayEl.remove();
      trayEl = null;
    }

    if (vacuums.length === 0) return;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = buildTrayHtml();
    trayEl = wrapper.firstChild;
    container.appendChild(trayEl);

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (trayEl) trayEl.classList.add('visible');
      });
    });

    bindTrayEvents();
  }

  function bindTrayEvents() {
    if (!trayEl) return;

    var removeBtns = trayEl.querySelectorAll('.qsv-vct-item-remove');
    for (var i = 0; i < removeBtns.length; i++) {
      removeBtns[i].addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        removeMachine(this.getAttribute('data-handle'));
      });
    }

    var clearBtn = trayEl.querySelector('.qsv-vct-clear');
    if (clearBtn) {
      clearBtn.addEventListener('click', function(e) {
        e.preventDefault();
        clearAll();
      });
    }

    var compareBtn = trayEl.querySelector('.qsv-vct-compare-btn');
    if (compareBtn && isOnComparePage) {
      compareBtn.addEventListener('click', function(e) {
        e.preventDefault();
        window.dispatchEvent(new CustomEvent('qsv-vacuum-compare-now'));
      });
    }

    var collapseBtn = trayEl.querySelector('.qsv-vct-collapse');
    if (collapseBtn) {
      collapseBtn.addEventListener('click', function(e) {
        e.preventDefault();
        trayEl.classList.toggle('collapsed');
      });
    }
  }

  function showMaxMessage() {
    if (!trayEl) return;
    var msg = trayEl.querySelector('.qsv-vct-max-msg');
    if (!msg) return;
    msg.classList.add('show');
    if (maxMsgTimeout) clearTimeout(maxMsgTimeout);
    maxMsgTimeout = setTimeout(function() {
      msg.classList.remove('show');
    }, 3000);
  }

  // ---- Button Injection ----

  var btnEl = null;

  function findInjectionPoint() {
    var selectors = [
      '.product-form__buttons',
      '.product-form__submit',
      'form[action*="/cart/add"] .shopify-payment-button',
      'form[action*="/cart/add"] button[type="submit"]',
      '.product-form',
      '.product__info-wrapper',
      '.product-single__meta'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function injectButton() {
    if (!isVacuum || !currentProduct) return false;
    var target = findInjectionPoint();
    if (!target) return false;

    var selected = isSelected(currentProduct.handle);
    btnEl = document.createElement('button');
    btnEl.type = 'button';
    btnEl.id = 'qsv-vct-product-btn';
    btnEl.className = 'qsv-vct-btn' + (selected ? ' active' : '');
    btnEl.innerHTML = '<span class="qsv-vct-btn-icon">' + (selected ? '&#10003;' : '+') + '</span> ' +
      '<span class="qsv-vct-btn-text">' + (selected ? 'Added to Compare' : 'Add to Compare') + '</span>';

    btnEl.addEventListener('click', function(e) {
      e.preventDefault();
      toggleCurrent();
    });

    var insertAfter = target;
    if (target.tagName === 'BUTTON' || target.tagName === 'INPUT') {
      insertAfter = target.closest('.product-form__buttons') || target.parentElement;
    }

    if (insertAfter.nextSibling) {
      insertAfter.parentNode.insertBefore(btnEl, insertAfter.nextSibling);
    } else {
      insertAfter.parentNode.appendChild(btnEl);
    }
    return true;
  }

  function updateButton() {
    if (!btnEl || !currentProduct) return;
    var selected = isSelected(currentProduct.handle);
    btnEl.className = 'qsv-vct-btn' + (selected ? ' active' : '');
    btnEl.querySelector('.qsv-vct-btn-icon').innerHTML = selected ? '&#10003;' : '+';
    btnEl.querySelector('.qsv-vct-btn-text').textContent = selected ? 'Added to Compare' : 'Add to Compare';
  }

  // ---- Actions ----

  function toggleCurrent() {
    if (!currentProduct) return;
    if (isSelected(currentProduct.handle)) {
      removeMachine(currentProduct.handle);
    } else {
      addVacuum(currentProduct);
    }
  }

  function addVacuum(vacuumData) {
    if (isSelected(vacuumData.handle)) return;
    if (vacuums.length >= MAX_COMPARE) {
      showMaxMessage();
      return;
    }
    vacuums.push({
      handle: vacuumData.handle,
      title: vacuumData.title,
      image: vacuumData.image,
      url: vacuumData.url,
      price: vacuumData.price
    });
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
  }

  function removeMachine(handle) {
    vacuums = vacuums.filter(function(v) { return v.handle !== handle; });
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
  }

  function clearAll() {
    vacuums = [];
    saveState();
    renderTray();
    updateButton();
    broadcastUpdate();
  }

  // ---- URL Builder ----

  function buildCompareUrl() {
    var handles = vacuums.map(function(v) { return v.handle; });
    return COMPARE_PAGE + '?compare=' + handles.join(',');
  }

  // ---- Sync ----

  // Cross-tab sync via localStorage change events
  window.addEventListener('storage', function(e) {
    if (e.key !== STORAGE_KEY) return;
    vacuums = loadState();
    renderTray();
    updateButton();
  });

  // Same-tab sync via custom event (from vacuum-compare app)
  window.addEventListener('qsv-vacuum-compare-updated', function(e) {
    if (_broadcasting) return;
    vacuums = loadState();
    renderTray();
    updateButton();
  });

  // Listen for collapse/expand requests from the vacuum comparison app
  window.addEventListener('qsv-vacuum-compare-tray-collapse', function(e) {
    if (!trayEl) return;
    if (e.detail && e.detail.collapsed === true) {
      trayEl.classList.add('collapsed');
    } else {
      trayEl.classList.remove('collapsed');
    }
  });

  // ---- Utilities ----

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // ---- Init ----

  function init() {
    if (vacuums.length > 0) {
      renderTray();
    }
    if (isVacuum) {
      if (!injectButton()) {
        var retries = 0;
        var retryTimer = setInterval(function() {
          retries++;
          if (injectButton() || retries >= 10) {
            clearInterval(retryTimer);
          }
        }, 200);
      }
    }
  }

  init();

})();
